import { render, staticRenderFns } from "./MailEditor.vue?vue&type=template&id=d2066346&"
import script from "./MailEditor.vue?vue&type=script&lang=js&"
export * from "./MailEditor.vue?vue&type=script&lang=js&"
import style0 from "./MailEditor.vue?vue&type=style&index=0&id=d2066346&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports